import { formatEnumLabel } from '../common/helper';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';
import { ALL_VALUE } from './helper';
import { InternalApiScenarioType } from '../api-internal';

const scenarioTypeAll = {
  key: 'ALL',
  value: ALL_VALUE,
  label: 'All scenario types',
};
export const scenarioTypeDefault: DropdownOption = scenarioTypeAll;
export const SCENARIO_TYPE_PARAM = 'scenarioType';

export const getFilterScenarioTypes = () => {
  return [scenarioTypeAll].concat(
    (Object.keys(InternalApiScenarioType) as (keyof typeof InternalApiScenarioType)[])
      .filter((key) => key !== InternalApiScenarioType.PERIODIC_ENTITY)
      .map((key) => {
        const value = InternalApiScenarioType[key];
        return {
          key: key,
          value: value,
          label: formatEnumLabel(value),
        };
      })
  );
};

// Returns scenario type that is in effect. Taking into consideration user selection and query parameters.
export const scenarioTypeSelectedOrURLOrDefault = (selected: DropdownOption | undefined): DropdownOption => {
  if (selected !== undefined) {
    return selected;
  }

  const params = new URLSearchParams(location.search);
  const value = params.get(SCENARIO_TYPE_PARAM);
  if (value !== null) {
    const existing = getFilterScenarioTypes().find((k) => k.value === value);
    if (existing !== undefined) {
      return existing;
    }
  }

  return scenarioTypeDefault;
};

export const apiScenarioTypeToFetch = (selectedScenarioType: DropdownOption) => {
  if (selectedScenarioType.value === ALL_VALUE) {
    return undefined;
  }

  const apiType = InternalApiScenarioType[selectedScenarioType.key as keyof typeof InternalApiScenarioType];
  return apiType !== undefined ? [apiType] : undefined;
};

export const apiScenarioTypeToFetchForTransactionBacklog = (selectedScenarioType: DropdownOption | undefined) => {
  const scenarioType = scenarioTypeSelectedOrURLOrDefault(selectedScenarioType);
  return apiScenarioTypeToFetch(scenarioType);
};
